if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();
      this.urlToShare = '';
      this.clipboardButton = this.querySelector('.share-link');
      if (this.clipboardButton) {
        this.clipboardButton.addEventListener('click', this.copyToClipboard.bind(this, this.clipboardButton));
      }      
    }

    copyToClipboard(e) {
      const productURL = e.getAttribute('data-link') || '';
      const url = `${window.shopUrl}${productURL}`
      navigator.clipboard.writeText(url);
      this.clipboardButton.classList.add('shared-link');

      setTimeout(() => {
        this.clipboardButton.classList.remove('shared-link');
      }, 2000);
    }

    updateUrl(url) {
      this.urlToShare = url;
    }
  });
}
